export const BASE_PATH = "/stores";
export const ESHOP_BRAND = "eshops";
export const SM_PROGRAM_ID = 2;
export const SM_PROGRAM_IDENTIFIER = "snacks";
